import { createTablePageSlice } from "../helpers/createTablePageSlice";

export const StatisticsSlice = createTablePageSlice({
  reducerName: "statistics",
  getListEndpoint: "v1/system/ses/send-statistics",
});
